import {http} from '@/http/index.js';

async function loadAvatar(data) {
  return http.post('/girl/avatar', data).then((response) => response.data.data);
}

export {loadAvatar};
